import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { DATE_TIME_FORMAT } from '../constants';
import CheckboxInput from './CheckboxInput';
import { getSubStatus } from 'helpers/subs';
import { splitLongText } from 'helpers/text';

const SubList = ({
  subs,
  viewUrl,
  actionComponent,
  showEffectiveDate,
  showCheckbox,
  selectedSubs,
  onCheckboxChange,
  isSimo,
}) => (
  <div>
    <table className="table">
      <thead>
        <tr>
          {showCheckbox && <th></th>}
          <th>ID</th>
          <th>First Name</th>
          <th>Last Name</th>
          <th>{isSimo ? 'Device SN' : 'MDN'}</th>
          <th>Status</th>
          {showEffectiveDate && <th>Effective Date</th>}
          <th>User ID</th>
          <th>Agent</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {subs.length > 0 &&
          subs.map((sub) => (
            <tr key={sub.id}>
              {showCheckbox ? (
                !isSimo || (isSimo && sub.cycle_type === 'activation') ? (
                  <td className="checkbox-cell">
                    <CheckboxInput
                      input={{
                        onChange: () => onCheckboxChange(sub.id),
                        checked: selectedSubs.includes(sub.id),
                      }}
                    />
                  </td>
                ) : (
                  <td></td>
                )
              ) : null}
              <td>{sub.id}</td>
              <td>{splitLongText(sub.first_name)}</td>
              <td>{splitLongText(sub.last_name)}</td>
              <td>{isSimo ? sub.device_sn : sub.mdn}</td>
              <td>{getSubStatus(sub)}</td>
              {showEffectiveDate && (
                <td>
                  {sub.effective_date
                    ? moment(sub.effective_date).format(DATE_TIME_FORMAT)
                    : ''}
                </td>
              )}
              <td>{sub.user_profile}</td>
              <td>{sub.agent_name && sub.agent_name.split(' ')[0]}</td>
              <td>
                {actionComponent ? (
                  actionComponent(sub)
                ) : (
                  <Link to={viewUrl(sub.id)}>View</Link>
                )}
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  </div>
);

export default SubList;
